<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.66602 12.9987C2.66602 12.5567 2.84161 12.1327 3.15417 11.8202C3.46673 11.5076 3.89065 11.332 4.33268 11.332H13.3327"
            stroke="#404245" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M4.33268 1.33203H13.3327V14.6654H4.33268C3.89065 14.6654 3.46673 14.4898 3.15417 14.1772C2.84161 13.8646 2.66602 13.4407 2.66602 12.9987V2.9987C2.66602 2.55667 2.84161 2.13275 3.15417 1.82019C3.46673 1.50763 3.89065 1.33203 4.33268 1.33203Z"
            stroke="#404245" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

</template>